// Common component overrides for both light and dark themes
export const componentOverrides = {
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          color: '#1565c0',
          borderRadius: '10px',
          borderWidth: '1px',
          borderColor: '#2196f3',
          border: '1px solid',
          backgroundColor: '#90caf9',
        }
      }
    },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.sidebar.background,
        color: theme.palette.sidebar.text,
        border: 'none',
        //boxShadow: '0 4px 24px 0 rgba(34, 41, 47, 0.06)',
        borderRightWidth:1,
        borderRightStyle:'solid',
        borderRightColor:theme.palette.sidebar.divider,
        marginTop: '0px',
        marginLeft: '0px',
        marginBottom: '0px',
        borderRadius: '0px',
        height: 'calc(100vh)', // Adjust for top/bottom margin
      }),
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.topbar.background,
        color: theme.palette.topbar.text,
        margin: {
          xs: '0',         // No margin on mobile
          md: '10px 24px 0 24px', // Margin on desktop
        },
        marginTop: '0px',
        borderRadius: '0px',
        boxShadow: '0 4px 24px 0 rgba(34, 41, 47, 0.06)',
        width: {
          xs: '100%',      // Full width on mobile
          md: 'calc(100%)', // Reduced width on desktop
        },
        left: {
          xs: 0,
          md: '0px',
        },
        right: {
          xs: 0,
          md: '0px',
        },
      }),
    },
  },
  // Custom class for sidebar menu items
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: '12px',
        margin: '4px 8px',
        transition: 'all 0.2s',
        '&.SidebarMenuItem-active': {
          backgroundColor: theme.palette.sidebar.menuItem.backgroundActive,
          boxShadow: '0 2px 8px 0 rgba(34, 41, 47, 0.04)',
          borderStyle: 'solid',
          borderColor: theme.palette.primary.light ,
          borderWidth:'2px'
        },
        '&:hover': {
          backgroundColor: theme.palette.sidebar.menuItem.backgroundHover,
          boxShadow: '0 2px 8px 0 rgba(34, 41, 47, 0.04)',
        },
      }),
    },
  },
}; 